import {useState} from 'react';

import {keyframes, Keyframes} from 'styled-components';

export const DELIVERY_TRACKER_ANIMATION_SECONDS = 2;

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
 
  100% {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
 
  100% {
    opacity: 0;
  }
`;

export const useDeliveryTrackerAnimation = () => {
  const [keyFrame, setKeyFrame] = useState<Keyframes | null>(null);

  const activateAnimation = (changeState: () => void) => {
    setTimeout(() => {
      setKeyFrame(fadeIn);
      changeState();
      setTimeout(() => setKeyFrame(null), 1000 * DELIVERY_TRACKER_ANIMATION_SECONDS);
    }, 1000 * DELIVERY_TRACKER_ANIMATION_SECONDS);
    setKeyFrame(fadeOut);
  };

  return {keyFrame, activateAnimation};
};
